import { useIsMobile } from '../../../../../utils/getIsMobile';
import { DashboardPage } from '../../../../dashboard/DashboardPage';
import { Dialog, DialogContent } from '../../../../feedback/Dialog';
import { useDialogScroll } from '../../../../feedback/hooks/useDialogScroll';
import { DataTestId } from '../../../../layout/DataTestIdWrapper';
import { Flex } from '../../../../layout/Flex';
import { CreateCollectionContent } from '../../../CreateCollectionContent/CreateCollectionContent';
import { Steps } from '../../typings';
import { CreateCollectionDialogFooter } from '../CreateCollectionDialogFooter/CreateCollectionDialogFooter';
import { CreateCollectionDialogTitle } from '../CreateCollectionDialogTitle/CreateCollectionDialogTitle';
import { ICreateCollectionDialogPageProps } from './typings';

export const CreateCollectionDialogPage: React.FC<ICreateCollectionDialogPageProps> = ({
    postCollection,
    selectedPosts,
    queryString,
    step,
    onSelectPost,
    onInputChange,
    onPostCardClick,
    onNextClick,
    onClose,
    onReport,
}) => {
    const isMobile = useIsMobile();
    const { modalContentRef, atTop, atBottom } = useDialogScroll();

    const content = (
        <>
            <CreateCollectionDialogTitle onClose={onClose} />
            <DialogContent
                pt={isMobile ? 0 : 2}
                pb={0}
                px={0}
                height="100%"
                dataTestId={DataTestId.CREATE_COLLECTION_DIALOG}
            >
                <CreateCollectionContent
                    atTop={atTop}
                    modalContentRef={modalContentRef}
                    onSelectPost={onSelectPost}
                    selectedPosts={selectedPosts}
                    onInputChange={onInputChange}
                    postCollection={postCollection}
                    inputText={queryString}
                    onPostCardClick={onPostCardClick}
                    onReport={onReport}
                />
            </DialogContent>
            <CreateCollectionDialogFooter
                selectedPosts={selectedPosts}
                onNextClick={onNextClick}
                atBottom={atBottom}
            />
        </>
    );

    if (isMobile) {
        return (
            <Dialog
                visibility={step === Steps.SEARCH ? undefined : 'hidden'}
                maxWidth={{ sm: '580px', md: '800px' }}
                height="100%"
                onClose={onClose}
                dataTestId={DataTestId.CREATE_COLLECTION_DIALOG}
            >
                {content}
            </Dialog>
        );
    }

    return (
        <DashboardPage height={{ xs: '100dvh', sm: '100vh' }} gridFeed>
            <Flex width="100%" minHeight="100%" py={{ sm: 2 }}>
                <Flex
                    p={2}
                    mx={{ sm: -2 }}
                    boxSizing={{ sm: 'content-box' }}
                    width="100%"
                    minHeight="100%"
                    direction="column"
                    alignItems="stretch"
                    borderRadius={{ sm: 2 }}
                    background="var(--background-primary)"
                    position="relative"
                >
                    {content}
                </Flex>
            </Flex>
        </DashboardPage>
    );
};
